import './JobPage.scss';
import JobPageContent from './JobPageContent';
import JobPageLoader from './JobPageLoader';
import usePageTitle from "../../hooks/PageTitle";

export default function JobPage() {
  usePageTitle("Job Opportunities");
  
  return (
    <JobPageLoader>
      <JobPageContent />
    </JobPageLoader>
  );
}
